'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _pluginsObjectExtend = require('plugins/object.extend');

var _pluginsObjectExtend2 = _interopRequireDefault(_pluginsObjectExtend);

/* Stores */
var React = require('react');
var ModuleInspectorStore = require('stores/module-inspector');

/* Components */
var TitledGroup = require('components/ui/titled-group');
var ComponentTypeText = require('./text');
var ComponentTypeTextArea = require('./text-area');
var ComponentTypeMultiText = require('./multi-text');
var ComponentTypeNumber = require('./number');
var ComponentTypeDate = require('./date');
var ComponentTypeCheckbox = require('./checkbox');
var ComponentTypeButton = require('./button');
var ComponentTypeButtonGroup = require('./button-group');
var ComponentTypeSelect = require('./select');
var ComponentTypeDatasource = require('./datasource');
var ComponentTypeColor = require('./color');
var ComponentTypeImage = require('./image');
var ComponentTypeTranslationCollection = require('./translation-collection');

var componentTypes = {
  "text": ComponentTypeText,
  "text-area": ComponentTypeTextArea,
  "multi-text": ComponentTypeMultiText,
  "number": ComponentTypeNumber,
  "date": ComponentTypeDate,
  "checkbox": ComponentTypeCheckbox,
  "button": ComponentTypeButton,
  "button-group": ComponentTypeButtonGroup,
  "select": ComponentTypeSelect,
  "datasource": ComponentTypeDatasource,
  "color": ComponentTypeColor,
  "image": ComponentTypeImage,
  "translation-collection": ComponentTypeTranslationCollection
};

var ModuleInspectorPropertyTypeGroup = React.createClass({
  displayName: 'ModuleInspectorPropertyTypeGroup',

  getInitialState: function getInitialState() {
    return {
      value: {}
    };
  },

  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    var component = this;

    if (!prevProps.value && component.props.value) {
      component.value = component.props.value;
      component.setState({ value: component.props.value || {} });
    }
  },

  render: function render() {
    var component = this;
    var props = component.props;

    var values = props.values || [];

    componentTypes["multi-group"] = props.componentTypeMultiGroup;

    /* Translations */
    var baseTranslationKey = props.groupName + '_' + props.name;
    var groupTitle = ModuleInspectorStore.translate(baseTranslationKey);

    var itemNodes = values.map(function (item) {

      var Component = componentTypes[item.type];

      if (!Component) {
        return React.createElement(
          'div',
          { className: 'property-component' },
          'Failed to load'
        );
      }

      var itemValue = props.value ? props.value[item.name] : undefined;

      return React.createElement(
        'div',
        { key: item.name, className: 'property-component' },
        React.createElement(Component, _extends({
          ref: item.name
        }, item, {
          value: itemValue,
          groupName: baseTranslationKey,
          projectId: props.projectId,
          disabled: props.disabled,
          onPerformAction: component._onPerformAction,
          onChange: component._onChange.bind(null, item.name) }))
      );
    });

    return React.createElement(
      TitledGroup,
      { className: 'group-component', title: groupTitle },
      itemNodes
    );
  },

  _onChange: function _onChange(itemName, originalItemValue, itemValue) {
    var props = this.props;
    var value = (0, _pluginsObjectExtend2['default'])({}, props.value);

    value[itemName] = itemValue;

    if (props.onChange) {

      // Send original value and new value
      props.onChange(props.value, value);
    }
  },

  _onPerformAction: function _onPerformAction(buttonName) {
    var props = this.props;

    if (props.onPerformAction) {
      props.onPerformAction(buttonName);
    }
  }
});

module.exports = ModuleInspectorPropertyTypeGroup;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/project/playground/module/inspector/type/group.js
 **/